import { BranchHttpService } from './../http/branch-http.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class BranchListHttpResolverService implements Resolve<any> {
    constructor(private branchHttpService: BranchHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.branchHttpService.getAllBranches();
    }
}

@Injectable({
    providedIn: 'root',
})
export class BranchEditHttpResolverService implements Resolve<any> {
    constructor(private branchHttpService: BranchHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.branchHttpService.getBranchById(route.params.id);
    }
}
